<template>
  <div>
    <wc-dialog
      title='Working...'
      hideCancel
      :showDialog='showStatus'
      saveText='OK'
      width='300'
      @save="$emit('close')"
    >
      <br>
      <v-row v-for='(t, index) in tasks' :key='index' dense>
        <v-col cols='1'>
          {{ index + 1 }}
        </v-col>
        <v-col cols='10'>{{ t.text }}</v-col>
        <v-col cols='1' class='text-left'>
          <v-icon
            v-if='t.complete'
            color='success'
          >
            mdi-check
          </v-icon> 
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12'>
          <wc-loading line></wc-loading>
        </v-col>
      </v-row>
    </wc-dialog>
  </div>
</template>

<script>
export default {
  name: 'wc-status-dialog',
  props: {
    showStatus: {
      required: true,
      type: Boolean
    },
    tasks: {
      required: false
    }
  }
}
</script>
